import { type MiddlewareFunction, redirect } from 'react-router';
import { auth } from '@/services/auth';
import { signInOptions } from '@/services/me';
import { queryClientContext } from './query-client-context';

/**
 * The shell's guard. A signed-out visitor goes to the sign-in page; a signed-in
 * one signs in to the API before any page reads, since the first sign-in is
 * what creates the account. A refusal fails the navigation with its `Problem`.
 */
export const requireSignIn: MiddlewareFunction = async ({ context }) => {
  if (!(await auth.getAccessToken())) {
    throw redirect('/sign-in');
  }
  await context.get(queryClientContext).query(signInOptions());
};

/** The sign-in page is for signed-out visitors only. */
export async function signInLoader() {
  if (await auth.getAccessToken()) {
    throw redirect('/');
  }
  return null;
}
